var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilledPinned(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11742_32375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.72996 7.64998L13 5.53998C13.1273 5.46273 13.2358 5.358 13.3175 5.23345C13.3992 5.10889 13.4521 4.96766 13.4722 4.82006C13.4923 4.67246 13.4792 4.52224 13.4339 4.38035C13.3885 4.23847 13.312 4.10851 13.21 3.99998L9.99996 0.789981C9.89143 0.687946 9.76147 0.611447 9.61959 0.566074C9.4777 0.5207 9.32747 0.507598 9.17988 0.527725C9.03228 0.547851 8.89104 0.600699 8.76649 0.682405C8.64193 0.764111 8.53721 0.872613 8.45996 0.999981L6.29996 4.22998L1.80996 5.22998C1.70728 5.2549 1.613 5.30648 1.53666 5.37952C1.46031 5.45256 1.40461 5.54447 1.37518 5.64595C1.34575 5.74742 1.34364 5.85487 1.36907 5.95742C1.39449 6.05998 1.44654 6.154 1.51996 6.22998L7.66996 12.39C7.7478 12.4604 7.84251 12.5096 7.94493 12.5327C8.04734 12.5558 8.15399 12.5521 8.25455 12.522C8.35512 12.4918 8.44619 12.4362 8.51896 12.3605C8.59174 12.2848 8.64375 12.1916 8.66996 12.09L9.72996 7.64998Z",
    fill: "#312F2E",
    stroke: "#5A534D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.59 9.37988L0.5 13.4999",
    stroke: "#5A534D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11742_32375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledPinned);
export default __webpack_public_path__ + "static/media/FilledPinned.9289c94273a7d5af9a08c5bf8483072f.svg";
export { ForwardRef as ReactComponent };